import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { painPoints } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Problem() {
  return <section className="w-full bg-navy px-4 py-14 sm:px-6 sm:py-20" data-id="element-253" data-mp="2roexfv7cz2or">
      <div className="mx-auto max-w-3xl" data-id="element-254" data-mp="2rmkegmfndknb">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-255" data-mp="2mpk8scmpmjwq">Prima del Sistema</p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-white sm:text-4xl" data-id="element-256" data-mp="2hqh9z9xbp9x7">
          Dall’incertezza clinica a una pianificazione sicura
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-white/70" data-id="element-257" data-mp="28p10r5i8vduk">
          Non hai bisogno di altre informazioni raccolte a caso. Hai bisogno di un sistema che ti aiuti a capire cosa
          osservare, quali domande porti e quali decisioni prendere <em data-id="element-258" data-mp="1z36xd6h68pd">prima</em> di approvare un piano di trattamento.
        </p>

        <h3 className="mt-10 text-center font-display text-xl font-bold text-white sm:text-2xl" data-id="element-259" data-mp="1x07y3nch58i">
          Ti riconosci in queste situazioni?
        </h3>

        <ul className="mt-6 space-y-2.5" data-id="element-260" data-mp="19aewbnsnmx17">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-2xl bg-white/[0.06] p-4 ring-1 ring-white/10" data-id="element-261" data-mp="vax3mxc8mzmk">
              <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-300" aria-hidden="true" data-id="element-262" data-mp="10bku9hwk1eg9" />
              <span className="text-[14px] leading-relaxed text-white/85 sm:text-[15px]" data-id="element-263" data-mp="1o15nquqc3u3s">{point}</span>
            </li>)}
        </ul>

        <p className="mt-7 text-center text-[15px] font-semibold leading-relaxed text-white" data-id="element-264" data-mp="1ea1b41o4slc4">
          Se hai vissuto anche solo una di queste situazioni, il Sistema Maestro è stato creato per te.
        </p>

        <CtaBlock className="mt-8" label="Voglio un sistema di pianificazione chiaro" tone="dark" data-id="element-265" data-mp="26wvt8rxh78mf" />
      </div>
    </section>;
}